module.exports = __webpack_public_path__ + "static/media/1-en.b3e2a124.svg";